module.exports = __webpack_public_path__ + "img/couples-020.612234d2.jpg";